import { Box, Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MATERIA_COLORS = [
	{ bg: '#E3F2FD', accent: '#1565C0', stripe: '#1565C0' },
	{ bg: '#E8F5E9', accent: '#2E7D32', stripe: '#2E7D32' },
	{ bg: '#FFF3E0', accent: '#E65100', stripe: '#E65100' },
	{ bg: '#FCE4EC', accent: '#AD1457', stripe: '#AD1457' },
	{ bg: '#F3E5F5', accent: '#6A1B9A', stripe: '#6A1B9A' },
	{ bg: '#E0F7FA', accent: '#00697A', stripe: '#00697A' },
	{ bg: '#FFF8E1', accent: '#F57F17', stripe: '#F57F17' },
	{ bg: '#F1F8E9', accent: '#558B2F', stripe: '#558B2F' },
];

export const CardContainer = styled(Card)(({ theme }) => ({
	cursor: 'pointer',
	borderRadius: (theme.shape.borderRadius as number) * 2,
	transition: 'all 0.2s ease',
	border: `1px solid ${theme.palette.divider}`,
	overflow: 'hidden',
	'&:hover': {
		transform: 'translateY(-4px)',
		boxShadow: theme.shadows[8],
	},
}));

export const ColorStripe = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'stripecolor',
})<{ stripecolor: string }>(({ stripecolor }) => ({
	height: 6,
	backgroundColor: stripecolor,
}));

export const CardBody = styled(Box)(({ theme }) => ({
	padding: theme.spacing(3),
	display: 'flex',
	flexDirection: 'column',
	gap: theme.spacing(1.5),
}));

export const CardTopRow = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'flex-start',
	justifyContent: 'space-between',
	gap: theme.spacing(1),
}));

export const MateriaAvatar = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'bgcolor' && prop !== 'accentcolor',
})<{ bgcolor: string; accentcolor: string }>(({ bgcolor, accentcolor }) => ({
	width: 52,
	height: 52,
	borderRadius: 12,
	backgroundColor: bgcolor,
	color: accentcolor,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	fontSize: '1.1rem',
	fontWeight: 700,
	letterSpacing: '0.02em',
	flexShrink: 0,
}));

export const ResourceCountBadge = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'accentcolor',
})<{ accentcolor: string }>(({ accentcolor }) => ({
	display: 'inline-flex',
	alignItems: 'center',
	gap: 4,
	padding: '3px 10px',
	borderRadius: 20,
	fontSize: '0.72rem',
	fontWeight: 700,
	backgroundColor: accentcolor + '18',
	color: accentcolor,
	whiteSpace: 'nowrap',
}));

export const AddMateriaCardContainer = styled(Card)(({ theme }) => ({
	cursor: 'pointer',
	borderRadius: (theme.shape.borderRadius as number) * 2,
	border: `2px dashed ${theme.palette.divider}`,
	backgroundColor: 'transparent',
	boxShadow: 'none',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	minHeight: 180,
	gap: theme.spacing(1.5),
	transition: 'all 0.2s ease',
	padding: theme.spacing(3),
	'&:hover': {
		borderColor: theme.palette.primary.main,
		backgroundColor: theme.palette.primary.main + '08',
		boxShadow: theme.shadows[2],
	},
}));

export const AddIconCircle = styled(Box)(({ theme }) => ({
	width: 52,
	height: 52,
	borderRadius: '50%',
	backgroundColor: theme.palette.primary.main + '14',
	color: theme.palette.primary.main,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
}));
